import { Card } from "react-bootstrap";

export default function CourseStructure() {
  const resources = [
    {
      title: "KaaS Trust & Safety",
      description: "Our policies for instructors and students",
      link: "#",
    },
    {
      title: "Join the instructor community",
      description: "A place to connect with other instructors",
      link: "#",
    },
    {
      title: "Official KaaS Course: How to Create an Online Course",
      description:
        "Learn about course creation from the KaaS Instructor Team and experienced instructors",
      link: "#",
    },
  ];
  return (
    <div className="p-4">
      <h2 className="mb-4">Course structure</h2>

      <div className="d-flex gap-5">
        <div className="flex-grow-1">
          <div className="mb-5">
            <h3 className="h4 mb-3">There's a course in you. Plan it out.</h3>
            <p className="text-muted">
              Planning your course carefully will create a clear learning path
              for students and help you once you film. Think down to the details
              of each lecture including the skill you'll teach, estimated video
              length, practical activities to include, and how you'll create
              introductions and summaries.
            </p>
          </div>

          <div className="mb-5">
            <h3 className="h4">Tips</h3>

            <div className="mb-4">
              <h4 className="h5 mb-2">Start with your goals.</h4>
              <p className="text-muted">
                Setting goals for what learners will accomplish in your course
                (also known as{" "}
                <a href="#" className="text-primary">
                  learning objectives
                </a>
                ) at the beginning will help you determine what content to
                include in your course and how you will teach the content to
                help your learners achieve the goals.
              </p>
            </div>

            <div>
              <h4 className="h5 mb-2">Create an outline.</h4>
              <p className="text-muted">
                Decide what skills you'll teach and how you'll teach them. Group
                related lectures into sections. Each section should have at
                least 3 lectures, and include at least one assignment or
                practical activity.{" "}
                <a href="#" className="text-primary">
                  Learn more
                </a>
                .
              </p>
            </div>
            <div>
              <h4 className="h5 mb-2">
                Introduce yourself and create momentum.
              </h4>
              <p className="text-muted">
                People online want to start learning quickly. Make an
                introduction section that gives learners something to be excited
                about in the first 10 minutes.
              </p>
            </div>
            <div>
              <h4 className="h5 mb-2">
                Sections have a clear learning objective.
              </h4>
              <p className="text-muted">
                Introduce each section by describing the section's goal and why
                it’s important. Give lectures and sections titles that reflect
                their content and have a logical flow.
              </p>
            </div>
            <div>
              <h4 className="h5 mb-2">Lectures cover one concept.</h4>
              <p className="text-muted">
                A good lecture length is 2-7 minutes to keep students interested
                and help them study in short bursts. Cover a single topic in
                each lecture so learners can easily find and re-watch them
                later.
              </p>
            </div>
            <div>
              <h4 className="h5 mb-2">Mix and match your lecture types.</h4>
              <p className="text-muted">
                Alternate between filming yourself, your screen, and slides or
                other visuals. Showing yourself can help learners feel
                connected.
              </p>
            </div>
            <div>
              <h4 className="h5 mb-2">
                Practice activities create hands-on learning.
              </h4>
              <p className="text-muted">
                Help learners apply your lessons to their real world with
                projects, assignments, coding exercises, or worksheets.
              </p>
            </div>
          </div>
          <div className="container mt-4">
            <h4 className="fw-bold">Requirements</h4>
            <ul className="list-unstyled">
              <li>
                🔹 See the{" "}
                <a href="#" className="text-primary text-decoration-underline">
                  complete list
                </a>{" "}
                of course quality requirements
              </li>
              <li>🔹 Your course must have at least five lectures</li>
              <li>
                🔹 All lectures must add up to at least 30+ minutes of total
                video
              </li>
              <li>
                🔹 Your course is composed of valuable educational content and
                free of promotional or distracting materials
              </li>
            </ul>
          </div>
          <div className="container mt-4">
            <h4 className="fw-bold">Resources</h4>
            {resources.map((resource, index) => (
              <div key={index} className="mb-3">
                <a
                  href={resource.link}
                  className="text-primary fw-bold text-decoration-underline"
                >
                  {resource.title}
                </a>
                <p className="m-0">{resource.description}</p>
              </div>
            ))}
          </div>
        </div>

        <Card className="bg-white shadow-sm" style={{ maxWidth: "300px" }}>
          <Card.Body className="text-center">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Screenshot%202025-02-05%20151331-AODwBwDyhhCl7FVv3tuM4Y1do04oSe.png"
              alt="Library illustration"
              className="mb-3"
              style={{ width: "100px", height: "auto" }}
            />
            <h4 className="h5 mb-3">Our library of resources</h4>
            <p className="text-muted mb-4">
              Tips and guides to structuring a course students love
            </p>
            <button className="btn btn-outline-primary">Teaching Center</button>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
